import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import { AppContainer } from 'react-hot-loader';
import styled, { ThemeProvider, createGlobalStyle } from 'styled-components';
import { StripeProvider } from 'react-stripe-elements';
import { SnackbarProvider } from '@components/DynamicSnackBar';
import theme from '@styles/theme';
import configureStore from '@redux/store';
import history from '@utils/history';
import { StripeConfig } from '@utils/config';
import { initPlaceService } from '@services/googleMap';

import '@assets/favicon.png';
import App from './App';
import './global.css';

export const store = configureStore();
initPlaceService();

const Root = styled.div`
  font-family: system-ui, sans-serif;
  line-height: 1.5;
`;
const Style = createGlobalStyle`
  * { box-sizing: border-box; }
  body{ margin:0; color: #34353c  }
`;

const Main = () => {
  return (
    <ThemeProvider theme={theme}>
      <Root>
        <Style />
        <Provider store={store}>
          <Router history={history}>
            <StripeProvider apiKey={StripeConfig.key}>
              <SnackbarProvider position="bottom-right">
                <App />
              </SnackbarProvider>
            </StripeProvider>
          </Router>
        </Provider>
      </Root>
    </ThemeProvider>
  );
};

export default App;

if (process.env.NODE_ENV === 'development') {
  const render = () => {
    ReactDOM.render(
      <AppContainer>
        <Main />
      </AppContainer>,
      document.getElementById('root')
    );
  };

  render();
  if (module.hot) {
    module.hot.accept('./App', render());
  }
} else {
  ReactDOM.render(<Main />, document.getElementById('root'));
}
